// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/components/Logo/style.scss
// module id = 744
// module chunks = 0